module.exports = __webpack_public_path__ + "img/ng_icon.4af80d43.svg";